export default __webpack_public_path__ + "static/media/white-tick.1baa3eb6.svg";